{
  "todayButton": "오늘 날짜",
  "nextMonth": "다음 달",
  "previousMonth": "이전 달",
  "nextYear": "다음 년도",
  "previousYear": "이전 년도",
  "weekdays": ["일", "월", "화", "수", "목", "금", "토"],
  "months": [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}
